export const ATTRACTION_IDS = [
  "machu-picchu",
  "studio-tour-london",
  "statue-liberty-crown",
  "alhambra-nasrid",
  "anne-frank-house",
] as const;

export type AttractionId = (typeof ATTRACTION_IDS)[number];

export const PLATFORM_LOCALES = ["en", "es", "pt", "fr", "de", "nl"] as const;
export type PlatformLocale = (typeof PLATFORM_LOCALES)[number];

export type ProviderId = "tuboleto" | "warner-webstore" | "statue-city-experiences" | "iacpos" | "anne-frank";

export type AttractionProduct = {
  routeId: number;
  circuitId: number;
  slug: string;
  name: string;
  providerProductCode: string;
  requiresTimeSlot: boolean;
  /** False when a product is useful editorial context but is not supported by the live monitor. */
  publicMonitoringEnabled?: boolean;
};

export type AttractionBrandProfile = {
  themeId: AttractionId;
  logo: {
    src: string;
    width: number;
    height: number;
  };
  palette: {
    background: string;
    surface: string;
    text: string;
    mutedText: string;
    border: string;
    accent: string;
    accentForeground: string;
    action: string;
    actionForeground: string;
    focus: string;
  };
  typography: {
    body: string;
    display: string;
    utility: string;
  };
  radius: string;
  surface: "clean" | "control-board" | "civic" | "plaster" | "archive";
  stripe: {
    colorPrimary: string;
    colorBackground: string;
    colorText: string;
    colorTextSecondary: string;
    colorTextPlaceholder: string;
    colorDanger: string;
    colorSuccess: string;
    fontFamily: string;
    borderRadius: string;
    focusBoxShadow: string;
  };
};

export type AttractionEmailProfile = {
  logo: {
    src: string;
    width: number;
    height: number;
  };
  footerDescription: string;
};

export type AttractionConfig = {
  id: AttractionId;
  providerId: ProviderId;
  brandName: string;
  emailFrom: string;
  shortName: string;
  publicHosts: readonly string[];
  stagingHost: string;
  customerHost: string;
  officialBookingUrl: string;
  timezone: string;
  locales: readonly PlatformLocale[];
  defaultLocale: PlatformLocale;
  brand: AttractionBrandProfile;
  email: AttractionEmailProfile;
  price: {
    amountCents: number;
    currency: "usd" | "gbp" | "eur";
    pricingVersion: string;
    maxPartySize: number;
  };
  sms: {
    enabled: boolean;
    /** Telnyx alphanumeric sender ID. Limited to 11 letters, numbers, or spaces. */
    senderId: string;
    amountCents: number;
    pricingVersion: string;
    maxMessages: number;
    minimumIntervalHours: number;
  };
  products: readonly AttractionProduct[];
};
